import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-100 px-2" }
const _hoisted_2 = { class: "configuration-searchinput pb-3" }
const _hoisted_3 = { style: {"height":"calc(100vh - 230px)","overflow-y":"auto"} }
const _hoisted_4 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_edit = _resolveComponent("v-btn-edit")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.profile && !_ctx.isConsultation)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "px-2 py-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_back, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.profile.displayName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.displayName) = $event)),
                  label: "Nom du profil",
                  "hide-details": "",
                  rules: [(v) => !!v || 'Le nom du profil est requis'],
                  readonly: _ctx.readonly,
                  density: "compact",
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "rules", "readonly", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.profile.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile.type) = $event)),
                  items: _ctx.profileTypes,
                  "item-value": "value",
                  "item-title": (item) => item.text,
                  label: "Type",
                  "hide-details": "",
                  readonly: _ctx.readonly,
                  density: "compact",
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "items", "item-title", "readonly", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.profile.restrictionLevel,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile.restrictionLevel) = $event)),
                  items: _ctx.restrictionLevels,
                  label: "Niveau de restriction",
                  outlined: "",
                  "hide-details": "",
                  readonly: _ctx.readonly,
                  density: "compact",
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "items", "readonly", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.profile.homePage,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profile.homePage) = $event)),
                  items: _ctx.homePages,
                  label: "Page de démarrage",
                  outlined: "",
                  "hide-details": "",
                  readonly: _ctx.readonly,
                  density: "compact",
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "items", "readonly", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "d-flex justify-end pr-4"
            }, {
              default: _withCtx(() => [
                (_ctx.profile.originalProfileId)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      bottom: ""
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: "mr-2",
                          small: "",
                          fab: "",
                          elevation: "0"
                        }, props, {
                          color: "#FFF",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checksDialog = true))
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_badge, {
                              color: "red",
                              content: _ctx.errorsCount
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "primary",
                                  class: "pb-1"
                                }, {
                                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createTextVNode("$oss-warning")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["content"])
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "Contrôle de droits", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn_edit, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.update())),
                  disabled: _ctx.readonly || _ctx.errorsCount > 0
                }, null, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex justify-center default_card pt-2 pb-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.search) = $event)),
                label: "Rechercher",
                outlined: "",
                "hide-details": "",
                width: "100%",
                density: "compact",
                "append-inner-icon": "$search",
                clearable: "",
                "onClick:clear": _cache[8] || (_cache[8] = ($event: any) => (_ctx.search = ''))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.configuration, (values, keyTitle, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.displaySection(keyTitle))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        index
                          ? (_openBlock(), _createBlock(_component_v_divider, {
                              key: `d-${keyTitle}-title`
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(), _createBlock(_component_v_row, {
                          "no-gutters": "",
                          key: `${keyTitle}-title`,
                          class: "mb-4 configuration-title"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "configuration-value ma-0 title mt-2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`profile.${keyTitle}.title`)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { class: "pt-2" }, {
                              default: _withCtx(() => [
                                (_ctx.profile.readWrites[keyTitle])
                                  ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                      key: 0,
                                      modelValue: _ctx.profile.readWrites[keyTitle].readWrite,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.profile.readWrites[keyTitle].readWrite) = $event),
                                      inline: "",
                                      density: "compact",
                                      color: "primary",
                                      "hide-details": "",
                                      class: "mt-0",
                                      onChange: _ctx.onChangeReadWrite,
                                      readonly: _ctx.readonly,
                                      disabled: _ctx.isConsultation
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_radio, {
                                          label: "Pas d'accès",
                                          value: 0
                                        }),
                                        _createVNode(_component_v_radio, {
                                          label: "Lecture",
                                          value: 1,
                                          disabled: 
                                                _ctx.refProfile.readWrites[keyTitle].readWrite < 1 &&
                                                _ctx.profile.originalProfileId != null
                                            
                                        }, null, 8, ["disabled"]),
                                        _createVNode(_component_v_radio, {
                                          label: "Lecture/Ecriture",
                                          value: 3,
                                          disabled: 
                                                _ctx.refProfile.readWrites[keyTitle].readWrite < 2 &&
                                                _ctx.profile.originalProfileId != null
                                            
                                        }, null, 8, ["disabled"])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "readonly", "disabled"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, (conf, keyConf) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (_ctx.displayConfig(keyTitle, keyConf))
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  "no-gutters": "",
                                  key: `${keyTitle}-${keyConf}`,
                                  class: "configuration-value"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "d-flex align-center" }),
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.profile.configuration[keyTitle][keyConf],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.profile.configuration[keyTitle][keyConf]) = $event),
                                          "hide-details": "",
                                          class: "pt-0 mt-0",
                                          color: "primary",
                                          ripple: !_ctx.isConsultation,
                                          onChange: _ctx.onChangeReadWrite,
                                          label: _ctx.$t(`profile.${keyTitle}.values.${keyConf}`),
                                          readonly: _ctx.readonly || _ctx.isConsultation,
                                          disabled: 
                                                _ctx.checkForSliderRight(
                                                    _ctx.originalProfile.configuration[keyTitle][
                                                        keyConf
                                                    ],
                                                    _ctx.profile.configuration[keyTitle][keyConf],
                                                )
                                            
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "ripple", "onChange", "label", "readonly", "disabled"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ])
          ]),
          _: 1
        }),
        (_ctx.checksDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 0,
              modelValue: _ctx.checksDialog,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checksDialog) = $event)),
              title: "Contrôle des droits",
              onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checksDialog = false)),
              width: "30vw"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        (!_ctx.errorsCount)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
                              _createVNode(_component_v_icon, {
                                class: "mr-2",
                                color: "primary"
                              }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("$oss-circle-check")
                                ])),
                                _: 1
                              }),
                              _cache[14] || (_cache[14] = _createTextVNode(" Tous les contrôles ont été validés "))
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.errorsCount = 1)
                                ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.errorsCount) + " droit surélévé :", 1))
                                : _createCommentVNode("", true),
                              (_ctx.errorsCount > 1)
                                ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.errorsCount) + " droits surélévés :", 1))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages, (errorMessage) => {
                                return (_openBlock(), _createElementBlock("h4", {
                                  key: errorMessage,
                                  class: "mr-2"
                                }, [
                                  _createVNode(_component_v_icon, {
                                    class: "mr-2",
                                    color: "red"
                                  }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode("$oss-warning")
                                    ])),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(errorMessage), 1)
                                ]))
                              }), 128))
                            ], 64))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}